import React from "react";
import "./modal.css";
// import lettemicael from "../images/LettemicaelMezghebeBanks.jpg";

const Announcement = ({ isOpen, onClose }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">


        <div className="tigrigna">
          <p className="message">
            ዝኸብርኩም/ን ኣባላት ረዲኤት ንተጋሩ ደቂ ኣንስትዮን ደግፍትናን፣
            <br />
            ክሳብ ሎሚ ብዝገበርናዮ ዝተፈላለየ ምህዞታትን ብዝገበርኩምዎ ተሳትፎን ካብ 2021 ክሳብ ሕዚ ካብ ኩለን
            ዞባታት ትግራይ ኣብ 10 ወረዳታት ንኣዴታት ስልጠና ሂብና፣ ብዝመረፀኦ ስራሕ እግሪ ኣትኪልና፣ ንልዕሊ
            1000 እስትንፋስ ሂወት ኣብ ምድሓን ንርከብ:: ሕዚ እውን እግሪ ምትካልና ቀፃልነት ክህልዎ ኣብዛ እንፆመላ
            እዋን ቁርሰይ ንኣዶ ትግራይ ይኹነለይ ብዝብል ናይ ቁርስና ወፃኢ ብዝዓቕምና ኣኪብና ክነወፊ ብኽብሪ
            ንላበው:: ንቤተሰብኩም: ፈተውትኹም ን ካልኦትን ክተባፅሑዎ ነዘኻኽር:: ወፈያ ንምግባር ኣብ ድሕረገፅና
            ዝተፈላዩ መንገድታት (<a href="/donate">Donation methods</a>) ኣሎኩም።
          </p>
        </div>
        <div className="english">
          <p>
            Dear Friends and Family:
            <br />
            The work we started together in 2021 continues to flourish. Since
            then, our project to uplift Tegaru women to become self-supporting
            (እግሪ ምትካል ኣዴታት ትግራይ) has expanded across 10 districts in the Tigray
            region, and have reached in saving more than 1000 lives with in
            these ten Woredas. We are continuing this project to save more
            lives.
          </p>

          <p>
            As many of us engage in fasting or Lent this season, we experience
            the sacrifice of skipping meals. I invite you to extend that
            sacrifice to a greater purpose. For every meal you skip, please
            consider donating the equivalent amount to support the women of
            Tigray, who have endured unimaginable hardship due to war and
            poverty. Your generous contribution can make a world of difference
            in their lives through Rediet for Tegaru Women, our charity
            organization.{" "}
          </p>

          <p>
            Thank you for your compassion and support. Together, we can bring
            hope and relief to those in desperate need. Please share this with
            family and friends. For donation options please visit the{" "}
            <a href="/donate">Donation options page</a>.{" "}
          </p>
          <p style={{ fontSize: "10px", color: "green" }}>
            This message will go away automatically after 2 minutes.
            <br/>
          <button type="button" onClick={onClose} className="btn btn-warning">
            Close
          </button>
          </p>
        </div>

        
      </div>
    </div>
  );
};

export default Announcement;
